import { render, staticRenderFns } from "./UnpackingPage.vue?vue&type=template&id=0c7bc610&scoped=true&"
import script from "./UnpackingPage.vue?vue&type=script&lang=js&"
export * from "./UnpackingPage.vue?vue&type=script&lang=js&"
import style0 from "./UnpackingPage.vue?vue&type=style&index=0&id=0c7bc610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7bc610",
  null
  
)

export default component.exports